import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { PlatformMe } from "@workcore/schemas";
import { isSignedIn, onAuthChange } from "./auth";
import { get } from "./api";

export function useSignedIn(): boolean {
  const [signedIn, set] = useState(isSignedIn());
  useEffect(() => onAuthChange(() => set(isSignedIn())), []);
  return signedIn;
}

/** Who the caller is at installation level: operator flag and workspace memberships. */
export function usePlatformMe() {
  const signedIn = useSignedIn();
  return useQuery({
    queryKey: ["platform-me"],
    queryFn: async () => PlatformMe.parse(await get("/v1/admin/me")),
    enabled: signedIn,
  });
}
